import HttpService from "../../infra/http/AxiosConfig";

export const QuadrosAvisoService = () => {
  const resource = 'quadroDeAvisos'
  const localStorageItem = 'readAvisos'
  const tiposEnum = {
    Resale: 3
  }

  return {
    getResaleAvisos() {
      return HttpService.AxiosClient.get(resource, { params: { tipo: tiposEnum.Resale } })
    },
    getReadAvisos() {
      return localStorage.getItem(localStorageItem) ? JSON.parse(localStorage.getItem(localStorageItem)) : []
    },
    setAvisosAsRead(avisosIds) {
      const currentSavedAvisos = localStorage.getItem(localStorageItem) ? JSON.parse(localStorage.getItem(localStorageItem)) : []
      localStorage.setItem(localStorageItem, JSON.stringify([...currentSavedAvisos, ...avisosIds]))
    }
  }
}
